"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = require("styled-components");
var NdsGlobalStyle_1 = __importDefault(require("./NdsGlobalStyle"));
function NdsThemeProviderBaseHoc(defaultTheme) {
    function NdsThemeProvider(props) {
        var theme = props.theme, children = props.children;
        return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NdsGlobalStyle_1.default, null),
                children)));
    }
    NdsThemeProvider.propTypes = {
        children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.node]),
        theme: prop_types_1.default.oneOfType([prop_types_1.default.object])
    };
    NdsThemeProvider.defaultProps = {
        children: null,
        theme: defaultTheme
    };
    return NdsThemeProvider;
}
exports.default = NdsThemeProviderBaseHoc;
//# sourceMappingURL=NdsThemeProviderBaseHoc.js.map